import { useCallback, useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { StyledLink } from "../../components/shared/Link";
import { Grid, Button } from "@mui/material";
import { StyledStack, StyledTitle } from "./News.style";
import DrawerCM from "components/shared/Drawer";
import { MdAdd } from "react-icons/md";
import NewsCard from "components/news/NewsCard";
import { getArticleRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import NotFound from "components/shared/NotFound/NotFound";
import { PAGINATION_LIMIT } from "constants";

export default function News() {
  const navigate = useNavigate();
  const [article, setArticle] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);

  const getArticle = useCallback(async () => {
    const res = await request({
      url: getArticleRequest,
      values: { skip: (page - 1) * PAGINATION_LIMIT, limit: PAGINATION_LIMIT },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      text: items.text,
      file: items.file,
      file_type: items.file_type,
      created_at: items.created_at,
    }));

    setArticle({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getArticle();
  }, [page, getArticle]);

  return (
    <DrawerCM title="آموزش">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2} spacing={1}>
            <StyledStack>
              <StyledTitle>
                <StyledLink to="/news/add">
                  <Button endIcon={<MdAdd />} variant="contained" mt={1}>
                    مقاله جدید
                  </Button>
                </StyledLink>
                <StyledLink to="/news/category">
                  <Button variant="contained" mt={1}>
                    سردسته ها
                  </Button>
                </StyledLink>
              </StyledTitle>
            </StyledStack>
            {article.data.length < 1 ? (
              <NotFound title="آموزشی یافت نشد" />
            ) : (
              <Grid container my={1} spacing={2}>
                <NewsCard
                  rows={article.data}
                  click={(articleId) => navigate("/news/" + articleId)}
                />
              </Grid>
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
